import { useContext } from 'react';
import { VendorContext, VendorConfig } from './VendorProvider';

export const useVendorConfig = () => {
  const config = useContext(VendorContext);
  return config as VendorConfig;
};
